import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const DSSE = () =>{
  
  return (
    <div className="Eresources">
    
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/dsse.jpg" alt=""/>
      </section>
      <section  className="research-box-area">
           <Container>
           <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/FindResources">
                  Find Resources
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>DSSE</BreadcrumbItem>
              </Breadcrumb>
              <div className='information-content'>
                <h2>DSSE</h2>
                {/* <p>THe HU LICS has access to the following online research databases:</p> */}
              </div>
              <Row className="ParentBorderBox">
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/Communication-of-the-ACM.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Coverage:</b> Monthly</p>
            <p><b>Subject/Topics: </b></p>
            <p>All area of Computer Science and Information Systems. The focus is on the practical implications of advances in information technology and associated management issues. </p>
        </div>
        <a class="link-btn" target="_blank" href="https://dl.acm.org/magazine/cacm"><img src="./assets/img/link-icon.svg" alt="" />ACM</a>
    </div>
    </Col>
    {/* */}
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/Power-and-Energy-Magazine.png " alt="" />
        </div>
        <div className="subjects">
            <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
            <p><b>Subject Coverage:</b></p>
            <p>Power, Energy and industry applications, Geoscience Including latest technological advancements, industry news, business trends and strategies, products, and publications </p>
        </div>
        <a class="link-btn" target="_blank" href="https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=8014"><img src="./assets/img/link-icon.svg" alt="" />IEEE: Power and Energy Magazine</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/Wireless-Communication.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Coverage:</b> All volumes from 2002 till 2022</p>
            <p><b>Subject Coverage:</b></p>
            <p>Communication, Networking and Broadcast Technologies, Computing Processing, Signal Processing and Analysis technical and policy volumes relating to personalized, location independent communication in all media (and Combinations of media), and at all protocol layers</p>
        </div>
        <a class="link-btn" target="_blank" href="https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=7742"><img src="./assets/img/link-icon.svg" alt="" />IEEE: Wireless Communications</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/Transaction-on-Circuits-and-Systems.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Coverage:</b> All volumes from 2004 till 2022</p>
            <p><b>Subject Coverage:</b></p>
            <p>Components, Circuits, Devices and Systems. The field of interest covered includes:- Circuits; Analog, digital and mixed signal Circuits and Systems -Nonlinear Circuits and Systems, Integrated Sensors, MEMS and Systems on Chip, Nanoscale Circuits and System Optoelectronic- Circuits and Systems, Power Electronics and Systems, Power Electronics and Systems – software for analog and logic Circuits and Systems Control aspects of Circuits and systems. </p>
        </div>
        <a class="link-btn" target="_blank" href="https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=8919"><img src="./assets/img/link-icon.svg" alt="" />IEEE: Transactions on circuits and systems</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/Transaction-on-Games.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Coverage:</b> All volumes from 2018 till 2022</p>
            <p><b>Subject Coverage:</b></p>
            <p>Scientific, technical and engineering aspects of games, other’s areas include bioengineering, Communication, Networking and Broadcast Technologies and Computing and Processing.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://ieeexplore.ieee.org/xpl/RecentIssue.jsp?punumber=7782673"><img src="./assets/img/link-icon.svg" alt="" />IEEE: Transactions on Games</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/informs-logo.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 12 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Operations Research, Management Science, Analytics, Information System, Decision Analysis, Research Theory, Marketing Research and Science, Computing and Information Technologies.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://pubsonline.informs.org/  "><img src="./assets/img/link-icon.svg" alt="" />Informs</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/ProQuest-Dissertations.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> Over 2.1 million full-text dissertations and theses</p>
            <p><b>Subject Coverage:</b></p>
            <p>Business and Economics, Medical Sciences, Science, Technology, Agriculture, Social Science, Arts, Humanities.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://www.proquest.com/"><img src="./assets/img/link-icon.svg" alt="" />ProQuest Dissertations & Theses Global</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/jstor-sustainability.png" alt="" />
        </div>
        <div className="subjects">
            {/* <p><b>Coverage:</b> All volumes from 2003 till 2022</p> */}
            <p><b>Subject Coverage:</b></p>
            <p>JSTOR Sustainability Collection Covers Subjects including environmental studies, environmental science, business, economics, law, aquatic & atmospheric sciences, ecology, urban studies and the built environment.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://www.jstor.org/sustainability/"><img src="./assets/img/link-icon.svg" alt="" />JSTOR: Sustainability Collection</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/springer-logo.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 2541 E-Journals, 102 E-Books, 57 Protocols</p>
            <p><b>Subject Coverage:</b></p>
            <p>Astronomy, Behavioral & Social Sciences, Computer Science, Engineering, Environmental Science, Geoscience, Humanities, Law, Life science, Mathematics, Medicine, Physics.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://link.springer.com/search?facet-content-type=%22Journal%22&showAll=false"><img src="./assets/img/link-icon.svg" alt="" />SpringerLink</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/SIAM.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 17 Journals </p>
            <p><b>Subject Coverage:</b></p>
            <p>SIAM fosters the development of applied Mathematical and computational methodologies needed in these various application areas. Applied mathematics in partnership with computational science is essential in solving many real-world problems</p>
        </div>
        <a class="link-btn" target="_blank" href="https://epubs.siam.org/journals/"><img src="./assets/img/link-icon.svg" alt="" />SIAM: Society for Industrial and Applied Mathematics</a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/wiley-logo.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 1576 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Architecture & Planning, Art & Applied Arts, Computer Science & Information Technology, Earth, Space & Environmental Science, Humanities, Physical Sciences & Engineering, Social & Behavioral Sciences.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://onlinelibrary.wiley.com/action/showPublications"><img src="./assets/img/link-icon.svg" alt="" />Wiley Online Library </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/taylor-logo.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resources:</b> 2921 E-Journals</p>
            <p><b>Subject Coverage:</b></p>
            <p>Arts & Humanities, Engineering, Computing & Technology, Media, Cultural & Communication Studies, Politics, International Relations &7 Area Studies, Sociology & Related Disciplines.</p>
        </div>
        <a class="link-btn" target="_blank" href="https://www.tandfonline.com/"><img src="./assets/img/link-icon.svg" alt="" />Taylor & Francis Online </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <div className="logosWrapbox">
            <img src="./assets/img/researchtool/eresources/imf-e-library.png" alt="" />
        </div>
        <div className="subjects">
            <p><b>Available Resource:</b> 11,000 Text Publications</p>
            <p><b>Subject Coverage:</b></p>
            <p>The IMF eLibrary includes the IMF Statistics, IMF Periodicals, IMF books and Analytical Papers. </p>
        </div>
        <a class="link-btn" target="_blank" href="https://www.elibrary.imf.org/"><img src="./assets/img/link-icon.svg" alt="" />IMF eLIBRARY </a>
    </div>
    </Col>
</Row>
           </Container>
      </section>
     
    </div>
  );
}
export default DSSE;